<adapt-common-shell [options]="commonShellOptions"></adapt-common-shell>
